/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Starting_ToastInputs */

const en_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting Audio Description...`)
};

const fr_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de la description audio...`)
};

const de_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportiere Audiobeschreibung...`)
};

const it_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione della descrizione audio...`)
};

const ru_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт аудиоописания...`)
};

const es_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando descripción de audio...`)
};

const zh_cn2_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出音频描述...`)
};

const ja_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明をエクスポートしています...`)
};

const hi_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात किया जा रहा है...`)
};

const pt_pt2_audio_description_export_starting_toast = /** @type {(inputs: Audio_Description_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando audiodescrição...`)
};

/**
* | output |
* | --- |
* | "Exporting Audio Description..." |
*
* @param {Audio_Description_Export_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_starting_toast = /** @type {((inputs?: Audio_Description_Export_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_starting_toast(inputs)
	if (locale === "de") return de_audio_description_export_starting_toast(inputs)
	if (locale === "it") return it_audio_description_export_starting_toast(inputs)
	if (locale === "ru") return ru_audio_description_export_starting_toast(inputs)
	if (locale === "es") return es_audio_description_export_starting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_starting_toast(inputs)
	if (locale === "ja") return ja_audio_description_export_starting_toast(inputs)
	if (locale === "hi") return hi_audio_description_export_starting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_starting_toast(inputs)
	return en_audio_description_export_starting_toast(inputs)
});